var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilepic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 67.5,
    fill: "",
    fillOpacity: 0.1,
    stroke: "#DB0716"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 65.1471C75.1937 65.1471 80.5 60.2399 80.5 53.5736C80.5 46.9072 75.1937 42 68 42C60.8125 42 55.5 46.9072 55.5 53.5736C55.5 60.2399 60.8125 65.1471 68 65.1471ZM68 70.9339C54.1937 70.9339 43 80.2622 43 91.7663V94H93V91.7663C93 80.2622 81.8063 70.9339 68 70.9339Z",
    fill: "#DB0716"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilepic);
export default __webpack_public_path__ + "static/media/profilepic.44ec26c3889b70c5a605559af0f93b1c.svg";
export { ForwardRef as ReactComponent };